// extracted by mini-css-extract-plugin
export default {"p_content":"f2a6e30d95"};